/*

Copyright © David Bushell | @dbushell | http://dbushell.com

*/

'use strict';

var $html = $(document.documentElement),
    $site = $('.site'),
		$body = $('body'),
    $burgerButton = document.querySelector('.js-burger'),
    $menu = $('.l-menu'),
    $scrollTopValue = 0;

// animating clip-path is not playing nice in Safari
// http://browserhacks.com/

var hasCSSClipPaths = !!window.chrome && !/constructor/i.test(window.HTMLElement);
var supportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;

if (hasCSSClipPaths) {
  $html.addClass('cssclippaths');
}

$(window).scrollTop(0);

var $modal   = null,
    $overlay = $('.overlay'),
    $wrapper = $('.modal-wrapper'),
    $ripple  = $('.overlay__ripple'),
    offsetY = window.pageYOffset;


function lockScroll(pointer) {

  $scrollTopValue = $(window).scrollTop() * -1;
  
  if ( document.querySelector('.barba-container').getAttribute('data-namespace') === 'about' ) {
    $html.addClass('overflow-visible');
    $html.addClass('overflow-visible--no-relative');
  } else {
    $html.addClass('overflow-visible');

    // overflow issue on mobile pages (prevent scrolling while modal is open)
    // setTimeout(function() {
      // if (document.body.classList.contains('mobile-device')) {
      //   // $('body').addClass('bg-blue');

      //   $('.barba-container').css('position','fixed').css('left','0px').css('right','0px').css('top',$scrollTopValue + 'px');.css('overflow-y','scroll');
      //   $('#barba-wrapper').css('overflow-y','scroll');
      //   $('.barba-container > *:first-child').addClass('js-open-menu-action');
      // }
    // }, 100);

  }


  var w2, w1 = $html[0].clientWidth;
  offsetY = window.pageYOffset;

  // add listener to disable scroll

  w2 = $html[0].clientWidth;
  // replace scrollbar with padding
  if (w2 > w1) {
	  $body.css('padding-right', w2 - w1);
  }
}

function unlockScroll() {
  $body.css('padding-right', '').removeClass('js-lock-scroll js-lock-pointer');

  var barbaContainerBgColor = document.querySelector('.barba-container').style.backgroundColor; 

  // overflow issue on mobile pages (prevent scrolling while modal is open)
  if (document.body.classList.contains('mobile-device')) {
        
    // $('.barba-container').css('position','').css('left','auto').css('right','auto').css('top','auto').css('overflow-y','auto');
    // $('#barba-wrapper').removeAttr('style');
    // $('.barba-container').removeAttr('style');

    if ( barbaContainerBgColor.length ) {
      document.querySelector('.barba-container').style.backgroundColor = barbaContainerBgColor;
    }

    if( $('.barba-container > *:first-child').hasClass('js-open-menu-action') ) {
      $('html,body').scrollTop($scrollTopValue * (-1));
    }

    Waypoint.refreshAll();
  }

  $html.removeClass('overflow-visible');
  $html.removeClass('overflow-visible--no-relative');
  
}

// return distance between two points
function dist(p1, p2) {
  var xs = p2[0] - p1[0];
  var ys = p2[1] - p1[1];
  return Math.sqrt((xs * xs) + (ys * ys));
}

// return max width of a circle needed to cover a rectangle
function fillViewport(p1, width, height) {
  // calc radius from centre to each corner
  var nw = dist(p1, [0,          0]),
      ne = dist(p1, [width,      0]),
      se = dist(p1, [width, height]),
      sw = dist(p1, [0,     height]);
  // return diameter required
  return 2 * Math.max(nw, ne, se, sw);
}

var openOverlay = function(btn, id) {
  $modal = $('.modal[data-modal="' + id + '"]');
  var bgClass = $modal.data('bg-class') || 'bg-blue';

  lockScroll(true);

  requestAnimationFrame(function() {

    $overlay.addClass('js-open').attr('data-modal', id);
    var bounds = btn.getBoundingClientRect();

    // activate burger close button
    $ripple.attr('class', function(i, c) {
        return c.replace(/(^|\s)bg-\S+/g, '');
    });
    $burgerButton.classList.add(bgClass);
    $burgerButton.classList.add('open');

    // get viewport dimensions
    var vw = $(window).width(),
        vh = $(window).height();

    // get position of the button centre
    var p1 = [bounds.left + bounds.width / 2, bounds.top + bounds.height / 2];

    // calc max diameter required to fill viewport
    var diameter = fillViewport(p1, vw, vh);

    if ( FISHFINGER.utils._screenSize().x < 400) {
      diameter = diameter + 60;
    }

    // pixels per second (animation speed)
    var pps = 20000;

    // scale minimum duration somewhat proportionally
    var duration = 300 + (Math.round((diameter / pps) * 1000) * 0.5);

    $ripple.css({
      'transition-duration' : duration + 'ms',
      'width'  : diameter,
      'height' : diameter,
      'left'   : p1[0],
      'top'    : p1[1]
    });

    if (hasCSSClipPaths && (id === 'contactForm' || id === 'menu')) {
      $modal.css('transition-duration', '300ms, ' + duration + 'ms');
      $modal.css('-webkit-clip-path', 'circle(' + (diameter/2) + 'px at 50% 50%)');
    }

    requestAnimationFrame(function() {
      $overlay.addClass('js-animate-in');
      $ripple.addClass(bgClass);

      $ripple.one('transitionend', function() {
        $overlay.addClass('js-animate-done');
        $body.removeClass('js-lock-pointer');
        $ripple.removeAttr('style');
        $modal.addClass('active');
      })
    });

    if ($('[data-destroy-fullpage-when-modal-on]').length) {
      setTimeout(function() {
        try {
          $.fn.fullpage.destroy('all');
        } catch(e) {
            null;
        };
      }, 700);
    }

    if ($('.js-black-navbar').length) {
      $('.js-black-navbar').addClass('l-navbar--no-bg');
      $('.l-navbar').removeClass('l-navbar--black');
    }
  });
};

var closeOverlay = function() {
    $body.addClass('js-lock-pointer');
    $burgerButton.classList.remove('open');
    $menu.removeClass('open');

    var bounds = $burgerButton.getBoundingClientRect();

    // get viewport dimensions
    var vw = $(window).width(),
        vh = $(window).height();

    // get position of the button centre
    var p1 = [FISHFINGER.utils._screenSize().x - bounds.left - (bounds.width / 2), bounds.top + bounds.height / 2];

    // calc max diameter required to fill viewport
    var diameter = fillViewport(p1, vw, vh) + 500;

    // pixels per second (animation speed)
    var pps = 20000;

    // scale minimum duration somewhat proportionally
    var duration = 500 + (Math.round((diameter / pps) * 1000) * 0.5);

    $ripple.css({
      'transition-duration' : duration + 'ms',
      'width'  : diameter,
      'height' : diameter,
      'left'   : '-255px',
      'top'    : - (diameter / 2) + 60
    });


  requestAnimationFrame(function() {
    $overlay.removeClass('js-animate-done');
    $modal.removeAttr('style');
    $overlay.removeClass('js-animate-in');
    $overlay.addClass('js-animate-out');
  });

  $ripple.one('transitionend', function() {
    $wrapper.scrollTop(0);
    $overlay.removeClass('js-open js-animate-done').removeAttr('data-modal').removeClass('js-animate-out');
    $ripple.removeAttr('style');
    unlockScroll();
  });

  if ($('#js-contact-form').length && $('#js-success-form-notification').length) {
    setTimeout(() => {
      $('#js-success-form-notification').fadeOut();
    }, 400);

    setTimeout(() => {
      $('#js-contact-form').fadeIn();
    }, 700);
  }

    if ($('[data-destroy-fullpage-when-modal-on]').length) {
      try {
        $.fn.fullpage.destroy('all');
      } catch(e) {
          null;
      };

      setTimeout(function() {
        $('#fullpage').fullpage({
          hybrid: true,
          fitToSection: true,
          fitToSectionDelay: 100,
          scrollingSpeed: 700,
          sectionSelector: '.js-fullpage-section',
          keyboardScrolling: false,
          scrollBar: false,
          autoScroll: false,
        });
      }, 200);

    }

    if ($('.l-navbar--no-bg').length) {
      $('.l-navbar--no-bg').removeClass('l-navbar--no-bg');
      $('.js-black-navbar').addClass('l-navbar--black');
    }

    setTimeout(function() {
      document.activeElement.blur();
      document.querySelector('body').focus();
    }, duration);
}

function circularModalEffect(settings = {}) {
  let modalTrigger = settings.triggerWithinBarbaContainer ? $('[data-modal][data-action="open"]') : $('.barba-container [data-modal][data-action="open"]');

  modalTrigger.on('click', function() {
    var btn = this;
    requestAnimationFrame(function() {
      openOverlay(btn, $(btn).data('modal'));
    });
  });

  $overlay.on('click', function() {
    requestAnimationFrame(function() {
      closeOverlay();
    });
  });

  $wrapper.on('click', function(e) {
    var $target = $(e.target);
    if ($target.hasClass('modal')) {
        return;
    }
    if ($target.parents('.modal').length && $target.data('action') !== 'close') {
      if (!$target.parents('[data-action="close"]').length) {
        return;
      }
    }
    e.preventDefault();
    requestAnimationFrame(function() {
      closeOverlay();
    });
  });
}

circularModalEffect();

// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel

// MIT license

(function() {
    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];
    for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame']
                                   || window[vendors[x]+'CancelRequestAnimationFrame'];
    }

    if (!window.requestAnimationFrame) {
        window.requestAnimationFrame = function(callback, element) {
            var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = window.setTimeout(function() { callback(currTime + timeToCall); },
              timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };
    }

    if (!window.cancelAnimationFrame) {
        window.cancelAnimationFrame = function(id) {
            clearTimeout(id);
        };
    }
}());
